var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Card } from '../Card';
import { Icons } from '../Icons';
export const AddressSearch = (_a) => {
    var { id, className, label, error, selectedItem, renderOption, onSelect, getInputVisibleValue, options, onInputChange, disabled, count = 1, isLoading, languageData, onInputFocus = () => { }, showFocusDropdown = false } = _a, props = __rest(_a, ["id", "className", "label", "error", "selectedItem", "renderOption", "onSelect", "getInputVisibleValue", "options", "onInputChange", "disabled", "count", "isLoading", "languageData", "onInputFocus", "showFocusDropdown"]);
    const [value, setValue] = useState('');
    const [optionsVisible, setOptionsVisible] = useState(false);
    const [focusContentVisible, setFocusContentVisible] = useState(false);
    const wrapperRef = useRef(null);
    const inputChange = (event) => {
        const inputValue = event.target.value;
        setValue(inputValue);
        setFocusContentVisible(false);
        if (!inputValue) {
            onInputChange('');
            return toggleOptionsVisible(false);
        }
        onInputChange(inputValue);
        if (inputValue.length >= count) {
            toggleOptionsVisible(true);
        }
    };
    const selectItem = selectedItem => {
        const selectedListItem = getInputVisibleValue(selectedItem);
        setValue(selectedListItem);
        onSelect(selectedItem);
        toggleOptionsVisible(false);
        setFocusContentVisible(false);
    };
    useEffect(() => {
        if (selectedItem) {
            if (typeof selectedItem === 'string') {
                return setValue(selectedItem);
            }
            setValue(getInputVisibleValue(selectedItem));
        }
    }, [selectedItem]);
    useEffect(() => {
        window.addEventListener('mousedown', handleClickOutside);
        window.addEventListener('keydown', handleClickOutside);
        return () => {
            window.removeEventListener('mousedown', handleClickOutside);
            window.removeEventListener('keydown', handleClickOutside);
        };
    });
    const handleClickOutside = event => {
        const { current: wrap } = wrapperRef;
        if ((wrap && !wrap.contains(event.target)) || event.keyCode === 9) {
            toggleOptionsVisible(false);
            setFocusContentVisible(false);
        }
    };
    const toggleOptionsVisible = (value) => {
        setOptionsVisible(value);
    };
    const onFocus = () => {
        if (showFocusDropdown) {
            onInputFocus();
            setFocusContentVisible(true);
        }
    };
    const noResults = React.createElement("div", { className: "search-no-results" }, languageData.noOptionsFound);
    const loadingData = React.createElement("div", { className: "search-no-results" }, languageData.loading);
    const getContent = () => {
        if (isLoading) {
            return React.createElement(Card, { className: "address-list-card" }, loadingData);
        }
        else if (options && options.length) {
            return (React.createElement(Card, { className: "address-list-card" },
                React.createElement("ul", { className: "address-list" }, options.map((option, index) => (React.createElement("li", { key: index, className: "address-list__address-list-item", onClick: () => selectItem(option) }, renderOption(option)))))));
        }
        return React.createElement(Card, { className: "address-list-card" }, noResults);
    };
    const getFrequentComplainersContent = () => {
        if (isLoading) {
            return React.createElement(Card, { className: "address-list-card" }, loadingData);
        }
        else if (options && options.length) {
            return (React.createElement(Card, { className: "address-list-card" },
                React.createElement("div", { className: "frequent-inquirer__title" }, languageData.frequentInquirers),
                React.createElement("ul", { className: "frequent-inquirer__list" }, options.map((option, index) => {
                    const nameArray = [];
                    [option.firstName, option.lastName].forEach((field) => {
                        if (field) {
                            nameArray.push(field.trimRight());
                        }
                    });
                    const name = nameArray.join(' ');
                    return (React.createElement("li", { key: index, className: "frequent-inquirer__list__item", onClick: () => selectItem(option) }, name));
                }))));
        }
        return React.createElement(Card, { className: "address-list-card" }, noResults);
    };
    return (React.createElement("div", { className: classNames(className, 'form-group address-search'), ref: wrapperRef },
        label && (React.createElement("label", { className: "form-group__label", htmlFor: id }, label)),
        React.createElement("div", { className: "form-group__form-field" },
            React.createElement("input", Object.assign({ className: classNames('form-group__form_field__input', {
                    'form-group__form_field__input-error': error,
                }), disabled: disabled, value: value }, props, { onChange: inputChange, autoComplete: "none", onFocus: onInputFocus && onFocus }))),
        optionsVisible && getContent(),
        focusContentVisible && getFrequentComplainersContent(),
        error && (React.createElement("div", { className: "form-group__error" },
            React.createElement(Icons, { size: 16, iconName: "ic-ui-exclamation-sign" }),
            React.createElement("p", { className: "form-group__error-text" }, error)))));
};
//# sourceMappingURL=AddressSearch.js.map